export default __webpack_public_path__ + "static/hero-gradient-bg-be6d0ea1132c12eb34e529020cfa52b2.png";